import { getPageData } from '../api/getPageData';

export const fetchPageData = (omsid) => getPageData(omsid);

export default fetchPageData;
